export default __webpack_public_path__ + "static/media/Logo-acnh2.1cfb1ea7.png";